/**
 * Symbia icon mark (just the stylized arrows, not the wordmark).
 *
 * Extracted from the Symbia corporate logo. The original SVG includes the
 * full "SYMBIA / LOGISTICS" wordmark; this component renders only the
 * graphic mark for use in compact header / favicon contexts.
 *
 * Two render modes:
 *   - Default: brand colors (blue #0076f9 arrows + purple #2f087b middle)
 *     Use this against light backgrounds.
 *   - monochrome="white" or monochrome="currentColor": single-color rendering
 *     for use inside dark surfaces (like the dark logo square in the header).
 */
export function SymbiaLogoMark({
    width = 24,
    height = 24,
    className,
    monochrome,
}: {
    width?: number | string;
    height?: number | string;
    className?: string;
    monochrome?: 'white' | 'currentColor' | string;
}) {
    const arrowFill = monochrome ?? '#0076f9';
    const middleFill = monochrome ?? '#2f087b';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="73 142 65 64"
            width={width}
            height={height}
            className={className}
            aria-label="Symbia"
            role="img"
        >
            {/* Outer arrows */}
            <g transform="translate(75.987 152.05)">
                <path
                    d="M129.313,170.969l-4.186-3.22-18.036-13.873L89.057,167.748l4.185,3.22,13.849-10.657,13.852,10.657,4.184,3.219,2.322,1.786-2.322,1.788,4.186,3.22,6.506-5.008Z"
                    transform="translate(-78.365 -153.875)"
                    fill={arrowFill}
                />
                <path
                    d="M118.995,184.1l-13.852,10.653L91.292,184.1l-4.186-3.22-2.32-1.788,2.323-1.786-4.184-3.219-6.509,5,6.507,5.008,4.182,3.216,18.037,13.875,18.036-13.875Z"
                    transform="translate(-76.416 -156.991)"
                    fill={arrowFill}
                />
            </g>
            {/* Middle connecting path */}
            <path
                d="M122.75,175.935l-2.322-1.787,2.322-1.786-4.183-3.219-2.323,1.786-11.529-8.868-11.527,8.867-2.322-1.785-4.185-3.22-2.323-1.786,20.357-15.661,24.554,18.879-1.173.9,7.744.876-.943-6.1-1.444,1.11-28.739-22.1-28.726,22.1,6.509,5.006,4.183,3.219L89,174.148l-2.324,1.787,4.186,3.221,2.323-1.787,11.527,8.867,11.529-8.867,2.323,1.787,4.183,3.216,2.323,1.788-20.359,15.661-24.526-18.86,1.158-.892-7.708-.89.908,6.12,1.461-1.127,28.708,22.084,28.729-22.1-6.506-5ZM104.714,179.8l-7.343-5.648,7.343-5.648,7.343,5.648Z"
                fill={middleFill}
            />
        </svg>
    );
}
